import ChatItem from './ChatItem';

import { Heading, Box} from '@chakra-ui/react'
 import './ChatItems.css';
 
import { useAuth } from '../AuthContext.js'

function ChatHistory(props) {
    const { user, isLoading } = useAuth();
    console.log("loading 1");
    if (isLoading) return "Loading...";

    return (
        <><Box bg='#D60270'
            border='5px' borderColor='#D60270'
            w="100%" h="70px" >
<div className="h2">Chats</div>
        </Box>
        <ul>
                {props.chats.filter(chat => ((chat.chatter1 === user.name ||
                    chat.chatter2 === user.name))).map(filteredChat => (
                        <ChatItem
                            key={filteredChat.test}
                            id={filteredChat.test}
                            chatter1={filteredChat.chatter1}
                            chatter2={filteredChat.chatter2}
                            date={filteredChat.date}
                            selectChat={props.selectChat} />
                    ))}
            </ul></>

    );
}

export default ChatHistory;